import { useContext } from 'react';

import { HistogramTooltipContext } from '../contexts/HistogramTooltipMode.context.js';

export const useHistogramTooltip = () => useContext(HistogramTooltipContext);
